import { Link } from "react-router-dom";
import "./Ambassadors.css";
import SwirlIcon from "./components/SwirlIcon";

const tiers = [
  {
    key: "active",
    className: "active",
    color: "var(--amb-orange)",
    size: 22,
    name: "Active",
    req: "Refer users, first 10 is the baseline target",
    reward: "Referral code live",
  },
  {
    key: "bronze",
    className: "bronze",
    color: "var(--amb-bronze)",
    size: 26,
    name: "Bronze",
    req: "15 successful users",
    reward: "₦5,000 + leaderboard",
  },
  {
    key: "silver",
    className: "silver",
    color: "var(--amb-silver)",
    size: 30,
    name: "Silver",
    req: "25 successful users",
    reward: "+₦10,000 + IG feature",
  },
  {
    key: "gold",
    className: "gold",
    color: "var(--amb-gold)",
    size: 34,
    name: "Gold",
    req: "50 successful users",
    reward: "+₦25,000 + rec. letter",
  },
];

const Rewards = () => {
  return (
    <div className="amb-page amb-rewards">
      <div className="amb-inner">
        <Link to="/ambassadors/apply" className="amb-back">
          ← Back
        </Link>

        <span className="amb-wordmark">
          squaay<span className="dot">.</span>
        </span>

        <div className="amb-headline">
          How far can <em>you</em> go?
        </div>
        <div className="amb-sub">
          Every referral moves you up a level. Here's what you unlock.
        </div>

        <div className="amb-ladder">
          {tiers.map((tier) => (
            <div className={`amb-tier ${tier.className}`} key={tier.key}>
              <div className="amb-icon-box">
                <SwirlIcon size={tier.size} stroke={tier.color} fill={tier.color} />
              </div>
              <div className="amb-tier-name">{tier.name}</div>
              <div className="amb-tier-req">{tier.req}</div>
              <div className="amb-tier-reward">{tier.reward}</div>
            </div>
          ))}
        </div>

        <div className="amb-rewards-footer">
          <div className="amb-cta-text">
            Your first referral is <span>one DM away.</span>
          </div>
          <Link to="/ambassadors/form" className="amb-pill amb-pill--light">
            Apply now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Rewards;
